export const CATEGORY_ICONS = [
  "⚽",
  "🏆",
  "🥅",
  "🎯",
  "⭐",
  "🔥",
  "⚡",
  "🎮",
  "📣",
  "🧠",
];
